'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["help", "tooltipClassName", "label"];
'use es6';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILink from 'UIComponents/link/UILink';
import UISelect from 'UIComponents/input/UISelect';
import { CustomizeLazyLoadingAttributesUrl, LazyLoadingTypes } from '../constants/shared';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nNameSpace = `RichTextLib`;
const i18nKey = suffix => `${i18nNameSpace}.lazyLoading.${suffix}`;
function LazyLoadingInput(props) {
  const {
      help,
      tooltipClassName,
      label
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const options = Object.keys(LazyLoadingTypes).map(loadingValue => ({
    text: I18n.text(i18nKey(`values.${loadingValue}`)),
    value: loadingValue
  }));
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey(label)
    }),
    help: help,
    tooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('help'),
      options: {
        learnMoreLink: /*#__PURE__*/_jsx(UILink, {
          href: CustomizeLazyLoadingAttributesUrl,
          external: true,
          onMouseDown: evt => evt.preventDefault(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${i18nNameSpace}.shared.learnMore`
          })
        })
      }
    }),
    tooltipPlacement: "top",
    tooltipProps: {
      innerClassName: tooltipClassName
    },
    children: /*#__PURE__*/_jsx(UISelect, Object.assign({
      options: options
    }, rest))
  });
}
export default LazyLoadingInput;